import { LocationStepProps } from '@/libs/onboarding';
import styles from './LocationsList.module.css';
import { Empty, Icon, LoadingProgress } from '@oolio-group/design-ui-react';
import { DeviceConfigHeader } from '../common/DeviceConfigHeader';
import { ErrorMessage } from '@/components/error-message/ErrorMessage';

export const LocationsList = ({
  venues,
  loading,
  error,
  searchTerm,
  onSelectStore,
  onBack,
  onRetry,
  onSearchChange,
  filteredVenues,
}: LocationStepProps) => {
  // Render the content area based on loading/data state
  const renderContent = () => {
    if (loading) {
      return <LoadingProgress color="var(--accent)" loading />;
    }

    if (error) {
      return <ErrorMessage message={error} onRetry={onRetry} />;
    }

    if (!venues || venues.length === 0) {
      return <Empty label="No locations found." />;
    }

    if (filteredVenues.length === 0) {
      return <Empty label="No matching stores found." />;
    }

    return (
      <div className={styles.locationsList}>
        {filteredVenues.map(venue => (
          <div key={venue.id} className={styles.venueSection}>
            <div className={styles.venueHeader}>{venue.name}</div>
            {venue.stores && venue.stores.length > 0 ? (
              venue.stores
                .filter(
                  store =>
                    !store.isDeleted &&
                    (searchTerm === '' ||
                      store.name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())),
                )
                .map(store => (
                  <button
                    key={store.id}
                    className={styles.storeItem}
                    onClick={() => onSelectStore(venue, store)}
                  >
                    <span className={styles.storeIconLeft}>
                      <Icon name="corner-down-right-alt" />
                    </span>
                    <span className={styles.storeName}>{store.name}</span>
                    <span className={styles.storeIcon}>
                      <Icon name="angle-right" />
                    </span>
                  </button>
                ))
            ) : (
              <p className={styles.emptyStores}>No stores available</p>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <DeviceConfigHeader
        title="Select a store to continue..."
        onBack={onBack}
        showSearch
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        searchLabel="Search stores..."
      />

      <div className={styles.contentArea}>{renderContent()}</div>
    </>
  );
};
